import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { LinearProgress } from '@material-ui/core';

interface FilesystemDownloadButtonProps {
  download: () => Promise<void>;
  progress: number;
  total: number;
  selectedCount: number;
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * Download All / Download Selected, shared by the table header (two panel layout) and the mobile
 * toolbar. The mobile layout drops the header column this button used to live in, so it has to be
 * reachable from somewhere else -- the checkbox column is only useful if the selection can be acted
 * on.
 */
export default function FilesystemDownloadButton(props: FilesystemDownloadButtonProps) {
  const { download, progress, total, selectedCount, disabled, style } = props;

  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      await download();
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <LinearProgress
        variant="determinate"
        value={(progress / (total || 1)) * 100}
        style={{ marginLeft: 8, ...style }}
      />
    );
  }

  return (
    <Button
      color="primary"
      size="small"
      disabled={disabled}
      onClick={handleDownload}
      style={{ whiteSpace: 'nowrap', paddingLeft: 6, paddingRight: 6, ...style }}
    >
      {selectedCount > 0 ? 'Download Selected' : 'Download All'}
    </Button>
  );
}
